.generatedContentLeaf span {
  animation: flash 1s ease-in-out;
}

@keyframes flash {
  0% {
    background-color: var(--global-color-purple-a-400);
  }

  100% {
    background-color: transparent;
  }
}
